import React from 'react'

export default function NotAdded (): JSX.Element {
    return (
        <div className="badge badge-light-danger m-0 p-2 py-1 border border-danger">Not added</div>
    )
}
